// Code generated by Prismic. DO NOT EDIT.

import Accordion from "./Accordion";
import ApplicationForm from "./ApplicationForm";
import CheckoutForm from "./CheckoutForm";
import CohortListing from "./CohortListing";
import Columns from "./Columns";
import Comparison from "./Comparison";
import CourseListing from "./CourseListing";
import CustomCode from "./CustomCode";
import ExampleWidget from "./ExampleWidget";
import Hero from "./Hero";
import ReusableContent from "./ReusableContent";
import RichText from "./RichText";
import ScholarshipForm from "./ScholarshipForm";
import Testimonial from "./Testimonial";
import Testimonials2 from "./Testimonials2";
import VideoCarousel from "./VideoCarousel";

export const components = {
	Accordion: Accordion,
	ApplicationForm: ApplicationForm,
	CheckoutForm: CheckoutForm,
	CohortListing: CohortListing,
	Columns: Columns,
	Comparison: Comparison,
	CourseListing: CourseListing,
	CustomCode: CustomCode,
	ExampleWidget: ExampleWidget,
	Hero: Hero,
	ReusableContent: ReusableContent,
	RichText: RichText,
	ScholarshipForm: ScholarshipForm,
	Testimonial: Testimonial,
	Testimonials2: Testimonials2,
	VideoCarousel: VideoCarousel
};